module.exports = ".lead {\n  font-weight: bold;\n  margin-bottom: 10px; }\n\na {\n  color: #ffc414; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/notfound-container/notfound-container.style.scss
// module id = 885
// module chunks = 2